var exports = {
  "B": "CustomerStoriesSection__D4VG4O",
  "j": "CustomerStoriesSection__Spacer__yZ5f7C",
};

module.exports = exports;
